import React from 'react';
import { Link } from 'react-router-dom';
import moment from 'moment';

function HomeBlogItem({ post }) {
    if (!post) return null;

    return (
        <article className="group cursor-pointer">
            <Link to={`/blog/${post.slug}`}>
                <div className="relative h-56 rounded-xl overflow-hidden mb-6">
                    <img 
                        className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" 
                        src={post.image} 
                        alt={post.name} 
                    />
                </div>
            </Link>
            <div className="flex items-center gap-3 mb-3">
                {post.category?.name && (
                    <span className="text-xs font-bold uppercase tracking-widest text-primary">
                        {post.category.name}
                    </span>
                )}
                <span className="w-1 h-1 bg-outline-variant rounded-full"></span>
                <span className="text-xs text-on-surface-variant">
                    {moment(post.creation_time).format('MMM DD, YYYY')}
                </span>
            </div>
            <Link to={`/blog/${post.slug}`}>
                <h3 className="text-xl font-bold mb-3 group-hover:text-primary transition-colors line-clamp-2">
                    {post.name}
                </h3>
            </Link>
            <div 
                className="text-on-surface-variant text-sm line-clamp-2"
                dangerouslySetInnerHTML={{ __html: post.text }}
            />
        </article>
    );
}

export default HomeBlogItem;